import { Incidencias } from './incidencia.model';

export class KanbanIncidencia {
  public titulo: String;
  public icon: String;
  public color: String;
  public lista: Incidencias[];
  public config: any;

  constructor(
    titulo: String,
    lista: Incidencias[],
    icon: String,
    color: String
  ) {
    this.titulo = titulo;
    this.lista = lista;
    this.icon = icon;
    this.color = color;
  }
}
